module.exports = __webpack_public_path__ + "sq23-a2662466.png";